<template>
  <div id="reservationsMain" class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Rezervasyonlar'"
        :buttons="cardButtons"
        @showUnvisible="openUnvisible(null)"
      ></cardHead>

      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels m-b-0 p-1rem border-bottom"
        ref="form"
        as="div"
      >
        <div class="groupBox border">
          <label>Arama Kriterleri</label>
          <!-- Admin: musteri (zorunlu) + misafir adi -->
          <div class="row">
            <div class="col-lg-3 col-md-4 col-12">
              <searchSelect
                :title="'Müşteri *'"
                v-model="model.CustomerId"
                :errors="errors"
                :rules="{ required: true }"
                :data="customerOptions"
              ></searchSelect>
            </div>
            <div class="col-lg-3 col-md-4 col-12">
              <formGroup
                :title="'Misafir Adı'"
                v-model="model.GuestName"
                :errors="errors"
                @keydown.enter="search"
              ></formGroup>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col voucher">
                  <formGroup
                    :title="'Voucher'"
                    v-model="model.Voucher"
                    :errors="errors"
                    @keydown.enter="search"
                    :buttons="true"
                  >
                    <template #buttons>
                      <Btn
                        class="btn btn-success btn-xs waves-effect text-center"
                        @click="search()"
                        :process="process"
                        @mouseover="openSearchVoucherType = true"
                        @mouseleave="openSearchVoucherType = false"
                        ><span class="fa fa-search"></span>
                      </Btn>
                      <div
                        class="dropdown-menu"
                        @mouseover="openSearchVoucherType = true"
                        @mouseleave="openSearchVoucherType = false"
                        :class="{ show: openSearchVoucherType }"
                        style="position: absolute; inset: 0px 0px auto auto; margin: 0px; transform: translate3d(0px, 38.5px, 0px);"
                      >
                        <a
                          class="dropdown-item"
                          :class="{ active: model.SearchVoucherType == 0 }"
                          href="javascript:;"
                          @click="
                            model.SearchVoucherType = 0;
                            search(true);
                          "
                          >Eşitleri Ara</a
                        >
                        <a
                          class="dropdown-item"
                          :class="{ active: model.SearchVoucherType == 1 }"
                          href="javascript:;"
                          @click="
                            model.SearchVoucherType = 1;
                            search(true);
                          "
                          >İçerenleri Ara</a
                        >
                      </div>
                    </template>
                  </formGroup>
                </div>
                <div class="col-4">
                  <formGroup
                    :title="'Türü'"
                    :as="'select'"
                    v-model="model.ReservationStatus"
                    :errors="errors"
                    @keydown.enter="search"
                  >
                    <template #input>
                      <option :value="null">Hepsi</option>
                      <option :value="1">New</option>
                      <option :value="2">Changed</option>
                      <option :value="3">Cancel</option>
                      <option :value="0">None</option>
                      <option :value="4">Online</option>
                      <option :value="-1">Special Request</option>
                      <option :value="5">On Request</option>
                    </template>
                  </formGroup>
                </div>
              </div>
            </div>
            <div class="col">
              <multiSelect
                :title="'Otel'"
                v-model="model.HotelIds"
                :errors="errors"
                :data="hotels.map((x) => ({ value: x.Id, title: x.Name }))"
              ></multiSelect>
            </div>
            <div class="col">
              <multiSelect
                :title="'Sağlayıcılar'"
                v-model="model.CustomerProviderIds"
                :errors="errors"
                :data="providers.map((x) => ({ value: x.Id, title: x.Name }))"
              ></multiSelect>
            </div>
            <div class="col">
              <formGroup
                :title="'Durumu'"
                :as="'select'"
                v-model="model.ConfirmStatus"
                :errors="errors"
                @keydown.enter="search"
              >
                <template #input>
                  <option :value="null"></option>
                  <option :value="1">Otel yazılımına kaydedilen</option>
                  <option :value="2">Otel yazılımı + Acente confirm</option>
                  <option :value="8">Otel yazılımı + Not confirm</option>
                  <option :value="3">Not Confirm</option>
                  <option :value="11">Acente Konfirm</option>
                  <option :value="9">Sadece Acente Konfirm</option>
                  <option :value="4">İşlem görmemiş</option>
                  <option :value="5">Tekrar gösterme yapılmış</option>
                  <option :value="6">Onaya gönderilmiş</option>
                  <option :value="7">Onaylanmış / Reddedilmiş</option>
                  <option :value="12">Onaydan Geri Çekilen</option>
                </template>
              </formGroup>
            </div>
          </div>
          <div class="row">
            <div class="col-lg col-sm-6 col-12">
              <formGroup
                :title="'Checkin Başlangıç'"
                :max="
                  model.EndCheckin == null || model.EndCheckin == ''
                    ? '9999-12-31'
                    : model.EndCheckin
                "
                type="date"
                v-model="model.BeginCheckin"
                :errors="errors"
                @keydown.enter="search"
              ></formGroup>
              <formGroup
                :title="'Checkin Bitiş'"
                :min="model.BeginCheckin"
                max="9999-12-31"
                type="date"
                v-model="model.EndCheckin"
                :errors="errors"
                @keydown.enter="search"
              ></formGroup>
            </div>
            <div class="col-lg col-sm-6 col-12">
              <formGroup
                :title="'Checkout Başlangıç'"
                :max="
                  model.EndCheckout == null || model.EndCheckout == ''
                    ? '9999-12-31'
                    : model.EndCheckout
                "
                type="date"
                v-model="model.BeginCheckout"
                :errors="errors"
                @keydown.enter="search"
              ></formGroup>
              <formGroup
                :title="'Checkout Bitiş'"
                :min="model.BeginCheckout"
                max="9999-12-31"
                type="date"
                v-model="model.EndCheckout"
                :errors="errors"
                @keydown.enter="search"
              ></formGroup>
            </div>
            <div class="col-lg col-sm-4 col-12">
              <div class="row m-0" style="flex-wrap:nowrap;">
                <div class="col p-0">
                  <formGroup
                    :title="'Satış Başlangıç'"
                    :max="
                      model.EndSale == null || model.EndSale == ''
                        ? '9999-12-31'
                        : model.EndSale
                    "
                    type="date"
                    v-model="model.BeginSale"
                    :errors="errors"
                    @keydown.enter="search"
                  ></formGroup>
                </div>
                <div class="col-auto p-0">
                  <input
                    type="time"
                    class="form-control"
                    style="border-left:none"
                    v-model="modelTime.BeginSale"
                    :disabled="model.BeginSale == null"
                  />
                </div>
              </div>
              <div class="row m-0" style="flex-wrap:nowrap;">
                <div class="col p-0">
                  <formGroup
                    :title="'Satış Bitiş'"
                    max="9999-12-31"
                    :min="model.BeginSale"
                    type="date"
                    v-model="model.EndSale"
                    :errors="errors"
                    @keydown.enter="search"
                  ></formGroup>
                </div>
                <div class="col-auto p-0">
                  <input
                    type="time"
                    class="form-control"
                    style="border-left:none"
                    v-model="modelTime.EndSale"
                    :disabled="model.EndSale == null"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg col-sm-4 col-12">
              <div class="row m-0" style="flex-wrap:nowrap;">
                <div class="col p-0">
                  <formGroup
                    :title="'Eklenme Başlangıç'"
                    :max="
                      model.EndAdd == null || model.EndAdd == ''
                        ? '9999-12-31'
                        : model.EndAdd
                    "
                    type="date"
                    v-model="model.BeginAdd"
                    :errors="errors"
                    @keydown.enter="search"
                  ></formGroup>
                </div>
                <div class="col-auto p-0">
                  <input
                    type="time"
                    class="form-control"
                    style="border-left:none"
                    v-model="modelTime.BeginAdd"
                    :disabled="model.BeginAdd == null"
                  />
                </div>
              </div>
              <div class="row m-0" style="flex-wrap:nowrap;">
                <div class="col p-0">
                  <formGroup
                    :title="'Eklenme Bitiş'"
                    max="9999-12-31"
                    :min="model.BeginAdd"
                    type="date"
                    v-model="model.EndAdd"
                    :errors="errors"
                    @keydown.enter="search"
                  ></formGroup>
                </div>
                <div class="col-auto p-0">
                  <input
                    type="time"
                    class="form-control"
                    style="border-left:none"
                    v-model="modelTime.EndAdd"
                    :disabled="model.EndAdd == null"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg col-sm-4 col-12">
              <div class="row m-0" style="flex-wrap:nowrap;">
                <div class="col p-0">
                  <formGroup
                    :title="'İşlem Başlangıç'"
                    :max="
                      model.EndProcess == null || model.EndProcess == ''
                        ? '9999-12-31'
                        : model.EndProcess
                    "
                    type="date"
                    v-model="model.BeginProcess"
                    :errors="errors"
                    @keydown.enter="search"
                  ></formGroup>
                </div>
                <div class="col-auto p-0">
                  <input
                    type="time"
                    class="form-control"
                    style="border-left:none"
                    v-model="modelTime.BeginProcess"
                    :disabled="model.BeginProcess == null"
                  />
                </div>
              </div>
              <div class="row m-0" style="flex-wrap:nowrap;">
                <div class="col p-0">
                  <formGroup
                    :title="'İşlem Bitiş'"
                    max="9999-12-31"
                    :min="model.BeginProcess"
                    type="date"
                    v-model="model.EndProcess"
                    :errors="errors"
                    @keydown.enter="search"
                  ></formGroup>
                </div>
                <div class="col-auto p-0">
                  <input
                    type="time"
                    class="form-control"
                    style="border-left:none"
                    v-model="modelTime.EndProcess"
                    :disabled="model.EndProcess == null"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="tright">
            <Btn
              class="btn btn-primary btn-sm btn-icon waves-effect waves-light p-r-10 m-t-0 m-l-0 m-b-0 m-r-10"
              @click="clear"
              :process="process"
              v-show="isClear"
              ><span class="btn-label m-0 p-0"><i class="fas fa-eraser"></i></span
              ><span class="p-l-20 p-r-10">Filtreyi Temizle</span></Btn
            >
            <Btn
              class="btn btn-success btn-icon waves-effect waves-light p-r-20 m-0"
              @click="search"
              :process="process"
              ><span class="btn-label m-0 p-0"><i class="fa fa-search"></i></span
              ><span class="p-l-20 p-r-10">Rezervasyon Ara</span></Btn
            >
          </div>
        </div>
      </Form>

      <div class="row m-0" v-if="data != null">
        <div class="col-auto filter p-0 border-right hidden-sm-down">
          <div class="inbox-panel">
            <ul class="list-group list-group-full">
              <li
                class="list-group-item"
                :class="{ active: filter.type.indexOf(0) > -1 }"
                @click="
                  filter.type = [0];
                  filter.approve = null;
                "
              >
                <a href="javascript:;"
                  ><i class="ti-id-badge"></i> Hepsi
                  <span class="badge badge-info">{{ data.Rows.length }}</span></a
                >
              </li>
              <li
                class="list-group-item border-top"
                :class="{ active: filter.type.indexOf(1) > -1 }"
                @click="addFilterType(1)"
              >
                <a href="javascript:;"
                  ><i class="ti-face-smile"></i> New
                  <span class="badge badge-success">{{
                    setRezTypeCount(1)
                  }}</span></a
                >
              </li>
              <li
                class="list-group-item border-top"
                :class="{ active: filter.type.indexOf(2) > -1 }"
                @click="addFilterType(2)"
              >
                <a href="javascript:;"
                  ><i class="ti-help-alt"></i> Changed
                  <span class="badge badge-warning">{{
                    setRezTypeCount(2)
                  }}</span></a
                >
              </li>
              <li
                class="list-group-item border-top"
                :class="{ active: filter.type.indexOf(3) > -1 }"
                @click="addFilterType(3)"
              >
                <a href="javascript:;"
                  ><i class="ti-face-sad"></i> Cancelled
                  <span class="badge badge-danger">{{
                    setRezTypeCount(3)
                  }}</span></a
                >
              </li>
              <li
                class="list-group-item border-top"
                :class="{ active: filter.type.indexOf('other') > -1 }"
                @click="addFilterType('other')"
              >
                <a href="javascript:;"
                  ><i class="ti-info-alt"></i> Diğerleri
                  <span class="badge badge-secondary">{{
                    setRezTypeCount()
                  }}</span></a
                >
              </li>
            </ul>
          </div>
          <div class="kr-provtree">
            <div class="kr-prov" v-for="p in providerFacet" :key="p.id">
              <div class="kr-prov-row">
                <span class="kr-cb">
                  <input
                    type="checkbox"
                    :id="'ph' + p.id"
                    class="filled-in chk-col-teal"
                    :checked="groups[p.id] != undefined"
                    @change="changeGroup(p.id)"
                  />
                  <label :for="'ph' + p.id"></label>
                </span>
                <span
                  class="kr-prov-name"
                  :class="{ clickable: p.agencies.length > 0 }"
                  @click="p.agencies.length && toggleGroup(p.id)"
                  >{{ p.name }}</span
                >
                <span class="kr-prov-count">{{ p.count }}</span>
                <i
                  v-if="p.agencies.length > 0"
                  class="kr-chevron"
                  :class="
                    openGroups.indexOf(p.id) > -1
                      ? 'fas fa-chevron-up'
                      : 'fas fa-chevron-down'
                  "
                  @click="toggleGroup(p.id)"
                ></i>
              </div>
              <div
                class="kr-prov-subs"
                v-if="p.agencies.length > 0 && openGroups.indexOf(p.id) > -1"
              >
                <div
                  class="kr-sub-row"
                  v-for="(a, i) in p.agencies"
                  :key="a.name"
                >
                  <span class="kr-cb">
                    <input
                      type="checkbox"
                      :id="'g' + p.id + '_' + i"
                      class="filled-in chk-col-teal"
                      :checked="
                        groups[p.id] != undefined &&
                          groups[p.id].indexOf(a.name) > -1
                      "
                      @change="changeGroup(p.id, a.name)"
                    />
                    <label :for="'g' + p.id + '_' + i"></label>
                  </span>
                  <span class="kr-sub-name" :title="a.name">{{ a.name }}</span>
                  <span class="kr-sub-count">{{ a.count }}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="inbox-panel"
            v-if="data.Rows.filter((x) => x.SoftwareId > 2).length > 0"
          >
            <ul class="list-group list-group-full">
              <li
                class="list-group-item border-top"
                :class="{ active: filter.approve == -1 }"
                @click="filter.approve = filter.approve == -1 ? null : -1"
              >
                <a href="javascript:;"
                  ><i class="fas fa-tasks text-info" style="font-size:14px"></i>
                  Onaydakiler
                  <span class="badge badge-info">{{
                    data.Rows.filter(
                      (x) => x.WaitApprove || x.ApproveStatus > 0
                    ).length
                  }}</span></a
                >
              </li>
              <li
                class="list-group-item border-top"
                :class="{ active: filter.approve == 0 }"
                @click="filter.approve = filter.approve == 0 ? null : 0"
              >
                <a href="javascript:;"
                  ><i
                    class="fas fa-exclamation-triangle text-warning"
                    style="font-size:14px"
                  ></i>
                  Bekleyenler
                  <span class="badge badge-warning">{{
                    data.Rows.filter((x) => x.WaitApprove).length
                  }}</span></a
                >
              </li>
              <li
                class="list-group-item border-top"
                :class="{ active: filter.approve == 1 }"
                @click="filter.approve = filter.approve == 1 ? null : 1"
              >
                <a href="javascript:;">
                  <i
                    class="fas fa-check-circle text-success"
                    style="font-size:14px"
                  ></i>
                  Onaylananlar
                  <span class="badge badge-success">{{
                    data.Rows.filter((x) => x.ApproveStatus == 1).length
                  }}</span></a
                >
              </li>
              <li
                class="list-group-item border-top"
                :class="{ active: filter.approve == 2 }"
                @click="filter.approve = filter.approve == 2 ? null : 2"
              >
                <a href="javascript:;"
                  ><i
                    class="fas fa-times-circle text-danger"
                    style="font-size:14px"
                  ></i>
                  Reddedilenler
                  <span class="badge badge-danger">{{
                    data.Rows.filter((x) => x.ApproveStatus == 2).length
                  }}</span></a
                >
              </li>
            </ul>
          </div>
        </div>

        <div class="col p-0">
          <!-- [SECIM+REUPLOAD gecici kapali] Geri acmak: bu yorumu kaldir + main.vue
               icindeki ayni etiketli ("[SECIM+REUPLOAD ...]") JS/CSS bloklarini ac,
               dataTable'a @cellClicked="clickedCell" ve
               @cellDoubleClicked="onCellDoubleClicked" ekle.
          <div v-if="getRows.length" class="kr-grid-toolbar">
            <label class="kr-selectall">
              <input
                type="checkbox"
                v-model="selectAll"
                @change="selectAllClick"
              />
              <span>Tümünü Seç</span>
            </label>
            <span v-if="selectedCount > 0" class="kr-sel-count"
              >{{ selectedCount }} seçili</span
            >
            <div class="kr-toolbar-spacer"></div>
            <Btn
              v-if="selectedCount > 0"
              class="btn-primary btn-sm kr-bulk-btn"
              @click="reUploadDocuments(selectedRows)"
              :process="reUploadProcess"
            >
              <i class="mdi mdi-file-refresh" style="margin-right:6px"></i
              >Dökümanı Yeniden Yükle ({{ selectedCount }})
            </Btn>
          </div>
          -->
          <dataTable
            :name="'adminReservationList'"
            ref="agGrid"
            :columnDefs="columnDefs"
            :rowHeight="30"
            :isSelectedRowCount="true"
            :data="getRows"
            @cellDoubleClicked="detailShow = $event.data"
            :addContextMenuItem="getContextMenuItems"
          ></dataTable>
        </div>
      </div>

      <load-area v-if="process"></load-area>
    </div>

    <unVisibleModal
      v-if="showNoShowAgainModal"
      :UnVisibleData="unVisibleModalRows"
      @close="showNoShowAgainModal = false"
      @refreshed="onUnvisibleRefreshed"
    />

  </div>

  <reservationJsonModal
    v-if="detailShow != null"
    :reservation="detailShow"
    :customerName="detailCustomerName"
    :idNames="detailIdNames"
    @close="detailShow = null"
    @deUnvisible="
      openUnvisible([$event]);
      detailShow = null;
    "
  ></reservationJsonModal>
</template>

<script>
import moment from "moment";
import multiSelect from "./../../../components/formGroup/multiSelect.vue";
import unVisibleModal from "./unVisibleModal.vue";
import reservationJsonModal from "./reservationJsonModal.vue";
// Admin rezervasyon listeleme. clientMainReservation yapisina sadik; fark:
// endpoint $appAxiosAdmin POST KOLAYREZ/Reservations/List (CustomerId zorunlu),
// row-click tam form yerine JSON modal acar. Provider/sub filtreleme facet
// agaciyla (Groups) yapilir. ClickUp: 86cauu7wb.
export default {
  name: "reservations",
  components: { multiSelect, unVisibleModal, reservationJsonModal },
  data() {
    return {
      data: null,
      process: false,
      detailShow: null,
      showNoShowAgainModal: false,
      unVisibleModalRows: [],
      // IsSaving kilidi acma istegi ucusta mi. Arama butonlarina bagli olan
      // `process` ile paylasilmaz, yoksa istek sirasinda arama da kilitlenir.
      isSavingProcess: false,
      /* [SECIM+REUPLOAD gecici kapali] Ana grid satir secimi state'i:
      selects: [],
      selectAll: false,
      reUploadProcess: false,
      */
      customers: [],
      // JSON modalinda SoftwareId/OperatorId adlarini gostermek icin
      // (bkz. detailIdNames). Ikisi de lean {Id, Name} lookup'i.
      softwares: [],
      operatorNames: [],
      hotels: [],
      providers: [],
      openSearchVoucherType: false,
      // Bayat yanit korumasi: her arama sayaci arttirir; then/catch yalniz
      // en guncel aramaya aitse islenir. (AbortController mevcut axios
      // 0.21'de no-op; asil koruma bu sayac.)
      searchSeq: 0,
      filter: {
        type: [0],
        approve: null,
      },
      groups: {},
      openGroups: [],
      model: {
        CustomerId: null,
        HotelIds: [],
        ProviderIds: [],
        CustomerProviderIds: [],
        Voucher: null,
        SearchVoucherType: 0,
        BeginCheckin: null,
        EndCheckin: null,
        BeginCheckout: null,
        EndCheckout: null,
        BeginSale: null,
        EndSale: null,
        BeginAdd: null,
        EndAdd: null,
        BeginProcess: null,
        EndProcess: null,
        ProcessUserId: null,
        ReservationStatus: null,
        ConfirmStatus: null,
        GuestName: null,
      },
      modelTime: {
        BeginSale: null,
        EndSale: null,
        BeginAdd: null,
        EndAdd: null,
        BeginProcess: null,
        EndProcess: null,
      },
      controller: null,
      columnDefs: [
        /* [SECIM+REUPLOAD gecici kapali] Sol secim kutusu:
        {
          filter: false,
          field: "isSelected",
          headerName: "",
          width: 30,
          cellRenderer: this.$CheckCellRenderer,
          cellClick: true,
          sortable: false,
          enableRowGroup: false,
        },
        */
        {
          headerName: "",
          filter: false,
          field: "NoteCount",
          sortable: true,
          cellClick: true,
          enableRowGroup: false,
          width: 34,
          cellRenderer: function(params) {
            if (params.value > 0) {
              // Mail ikonu + ustunde yanip sonen kirmizi nokta. Sinif tabanli
              // (asagidaki NON-SCOPED style blogu) -> ag-grid hucre HTML'ine
              // ulasir ve @keyframes animasyon calisir.
              return (
                '<span class="kr-note" title="Not var">' +
                '<i class="mdi mdi-email kr-note-mail"></i>' +
                '<span class="kr-note-dot"></span>' +
                "</span>"
              );
            } else {
              return null;
            }
          },
        },
        {
          headerName: "",
          filter: false,
          field: "CountryCode",
          sortable: true,
          cellClick: true,
          enableRowGroup: false,
          width: 34,
          cellRenderer: function(params) {
            if (params.data != undefined) {
              if (params.value == null) {
                return "";
              } else {
                return (
                  '<img src="/flags/' +
                  params.value.toLowerCase() +
                  '.svg" title="' +
                  params.data.CountryCode +
                  '" alt="' +
                  params.data.CountryCode +
                  '"/>'
                );
              }
            }
          },
          filterParams: { refreshValuesOnOpen: true },
        },
        {
          headerName: "Türü",
          filter: true,
          field: "ConfirmationTypeText",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          width: 80,
          cellRenderer: function(params) {
            if (params.data != undefined) {
              if (
                params.data.ConfirmationType == 0 ||
                params.data.ConfirmationType == -1
              ) {
                return "<b>None</b>";
              } else if (params.data.ConfirmationType == 1) {
                return "<b class='confirmationType new'>New</b>";
              } else if (params.data.ConfirmationType == 2) {
                return "<b class='confirmationType changed'>Changed</b>";
              } else if (params.data.ConfirmationType == 3) {
                return "<b class='confirmationType cancelled'>Cancelled</b>";
              } else if (params.data.ConfirmationType == 4) {
                return "<b class='confirmationType booked'>Booked</b>";
              } else if (params.data.ConfirmationType == 5) {
                return "<b class='confirmationType request'>Request</b>";
              }
            } else {
              if (params.value == "New") {
                return "<b class='confirmationType new'>New</b>";
              } else if (params.value == "Changed") {
                return "<b class='confirmationType changed'>Changed</b>";
              } else if (params.value == "Cancelled") {
                return "<b class='confirmationType cancelled'>Cancelled</b>";
              } else if (params.value == "Booked") {
                return "<b class='confirmationType booked'>Booked</b>";
              } else if (params.value == "Request") {
                return "<b class='confirmationType request'>Request</b>";
              } else {
                return params.value;
              }
            }
          },
          filterParams: { refreshValuesOnOpen: true },
        },
        {
          headerName: "Sağlayıcı",
          filter: true,
          field: "ProviderName",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          width: 100,
        },
        {
          headerName: "Acente",
          filter: true,
          field: "ProviderAgency",
          flex: 1,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          minWidth: 100,
          cellRenderer: function(params) {
            if (params.data != undefined) {
              return (
                "<span title='" +
                (params.data.AgencyName == null
                  ? params.data.ProviderAgency
                  : params.data.AgencyName +
                    " (" +
                    params.data.ProviderAgency +
                    ")") +
                "' class=" +
                (params.data.AgencyName != null ? "match" : "") +
                ">" +
                (params.data.AgencyName != null
                  ? params.data.AgencyName
                  : params.data.ProviderAgency) +
                "</span>"
              );
            } else {
              return params.value;
            }
          },
        },
        {
          headerName: "Voucher",
          filter: "agTextColumnFilter",
          field: "Voucher",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          width: 110,
          cellRenderer: function(params) {
            if (params.data == undefined) return params.value; // grup satiri guard
            let isMultiple = 0;
            let text = params.value;
            if (params.data.WaitApprove) {
              text =
                '<i class="fas fa-exclamation-triangle m-r-5 text-warning" title="Rezervasyon onay bekliyor!"></i>' +
                text;
            }
            if (params.data.ApproveStatus == 1) {
              text =
                '<i class="fas fa-check-circle m-r-5 text-success" title="Rezervasyon onaylandı."></i>' +
                text;
            }
            if (params.data.ApproveStatus == 2) {
              text =
                '<i class="fas fa-times-circle m-r-5 text-danger" title="Rezervasyon reddedildi."></i>' +
                text;
            }
            params.api.forEachNodeAfterFilter((element) => {
              if (element.data && element.data.Voucher == params.value) {
                isMultiple++;
              }
            });
            if (isMultiple > 1) {
              text = "<b class='confirmationType changed'>" + text + "</b>";
            }
            return text;
          },
        },
        {
          headerName: "Otel",
          filter: true,
          field: "HotelName",
          flex: 1,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          minWidth: 120,
          cellRenderer: function(params) {
            if (params.data != undefined) {
              return (
                "<span title='" +
                (params.data.HotelName == null
                  ? params.data.ProviderHotel
                  : params.data.HotelName +
                    " (" +
                    params.data.ProviderHotel +
                    ")") +
                "' class=" +
                (params.data.HotelName != null ? "match" : "") +
                ">" +
                (params.data.HotelName != null
                  ? params.data.HotelName
                  : params.data.ProviderHotel) +
                "</span>"
              );
            } else {
              return params.value;
            }
          },
          filterParams: { refreshValuesOnOpen: true },
        },
        {
          headerName: "Giriş",
          filter: false,
          field: "Checkin",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          width: 100,
          valueFormatter: function(params) {
            return params.value == null
              ? null
              : moment(new Date(params.value)).format("DD.MM.YYYY");
          },
        },
        {
          headerName: "Çıkış",
          filter: false,
          field: "Checkout",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          width: 100,
          valueFormatter: function(params) {
            return params.value == null
              ? null
              : moment(new Date(params.value)).format("DD.MM.YYYY");
          },
        },
        {
          headerName: "Eklenme Tarihi",
          filter: false,
          field: "AddDate",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          width: 140,
          valueFormatter: function(params) {
            if (params.value == null) {
              return null;
            } else {
              let AddDate = new Date(params.value);
              AddDate.setHours(AddDate.getHours() + 3);
              return moment(AddDate).format("DD.MM.YYYY HH:mm");
            }
          },
        },
        {
          headerName: "Satış Tarihi",
          filter: false,
          field: "ProviderSaleDate",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          width: 130,
          valueFormatter: function(params) {
            return params.value == null
              ? null
              : moment(new Date(params.value)).format("DD.MM.YYYY HH:mm");
          },
        },
        {
          headerName: "Pansiyon",
          filter: true,
          field: "ProviderBoardType",
          flex: 1,
          minWidth: 130,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          cellRenderer: function(params) {
            if (params.data != undefined) {
              return (
                "<span class=" +
                (params.data.HotelBoardTypeCode != null ? "match" : "") +
                ">" +
                params.data.ProviderBoardType +
                "</span>"
              );
            } else {
              return params.value;
            }
          },
        },
        {
          headerName: "Y+Ç+B",
          filter: true,
          field: "YCB",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          width: 90,
        },
        {
          headerName: "Kayıt No",
          filter: "agTextColumnFilter",
          field: "KNO",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          width: 95,
          valueGetter: function(params) {
            if (params.data == undefined) return null; // grup satiri guard
            if (params.data.SoftwareId == 15 || params.data.SoftwareId == 16) {
              return params.data.RezNo;
            } else {
              return params.data.KNO;
            }
          },
        },
        {
          headerName: "Oda",
          filter: true,
          field: "RoomCount",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          width: 70,
        },
        {
          headerName: "Oda Tipi",
          filter: true,
          field: "ProviderRoomType",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          width: 100,
          cellRenderer: function(params) {
            if (params.data != undefined) {
              return (
                "<span class=" +
                (params.data.HotelRoomTypeCode != null ? "match" : "") +
                ">" +
                params.data.ProviderRoomType +
                "</span>"
              );
            } else {
              return params.value;
            }
          },
        },
        {
          headerName: "Geceleme",
          filter: true,
          field: "Duration",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          width: 110,
        },
      ],
    };
  },
  watch: {
    "model.CustomerId"(id) {
      // Musteri degisince ona bagli secimleri sifirla + opsiyonlari yeniden yukle.
      this.model.HotelIds = [];
      this.model.CustomerProviderIds = [];
      this.loadCustomerOptions(id);
    },
  },
  created() {
    this.$appAxiosAdmin
      .get(`Customers`)
      .then((response) => {
        this.customers = this.$orderByArray(response.data, "Name", false, false);
      })
      .catch((err) => {
        this.$isError(err);
      });
    // Kucuk lookup listesi; yanit SoftwareId'yi cikplak sayi olarak donduruyor,
    // adini burada cozup modala geciriyoruz.
    this.$appAxiosAdmin
      .get(`Softwares`)
      .then((response) => {
        this.softwares = response.data || [];
      })
      .catch((err) => {
        // Toast yok: sadece bir ad etiketi eksik kalir, ekran calismaya devam eder.
        console.error("Softwares yuklenemedi:", err);
      });
    // OperatorsNames: {Id, Name} lean lookup (tourscope ekranlarinda kullaniliyor,
    // or. tourscope/operatorHotels/main.vue:242). Agir Operators/Country/{id}
    // yerine bu tercih edildi.
    this.$appAxiosAdmin
      .get(`OperatorsNames`)
      .then((response) => {
        this.operatorNames = response.data || [];
      })
      .catch((err) => {
        console.error("OperatorsNames yuklenemedi:", err);
      });
  },
  computed: {
    // Rezervasyon yanitinda CustomerId var, adi yok. Musteri listesi bu ekranda
    // zaten yukleniyor (created -> GET Customers), adi oradan cozup modala
    // geciriyoruz. Kalici cozum: backend yanitina CustomerName eklenmesi.
    detailCustomerName() {
      const id = this.detailShow && this.detailShow.CustomerId;
      if (!id) return null;
      const c = (this.customers || []).find((x) => x.Id == id);
      return c ? c.Name : null;
    },
    // Cikplak sayi donen *Id alanlarinin ad karsiliklari. Yanitta 18 *Id alani
    // var, 11'inin adi zaten geliyor (ProviderName/HotelName/ApproverUsername...).
    // Kalanlardan ekranda lookup'i hazir olan ikisini burada cozuyoruz; digerleri
    // (CustomerProviderId, OperatorId, MailId, DirectoryId, ApproveReasonId)
    // backend'den *Name olarak istenecek.
    detailIdNames() {
      const r = this.detailShow;
      if (!r) return {};
      const out = {};
      const cust = (this.customers || []).find((x) => x.Id == r.CustomerId);
      if (cust) out.CustomerId = cust.Name;
      const sw = (this.softwares || []).find((x) => x.Id == r.SoftwareId);
      if (sw) out.SoftwareId = sw.Name;
      const op = (this.operatorNames || []).find((x) => x.Id == r.OperatorId);
      if (op) out.OperatorId = op.Name;
      // CustomerProviderId: EK ISTEK YOK ve kimlik bilgisi iceren yanita hic
      // dokunmadan. Kaynak liste yanitinin kendi Groups agaci (yukarida :1680'de
      // saklaniyor): { ProviderId, ProviderName, Subs: [{ CustomerProviderId,
      // Username }] }. Icinde sifre/proxy alani YOK.
      // Bilerek kullanilmayanlar: global KOLAYREZ/CustomerProviders (tum
      // musterilerin Password/ProxyPassword'u) ve KOLAYREZ/CustomerProviders/{Id}
      // (~45 alanlik edit modeli, ProviderName bile donmuyor).
      const groups = (this.data && this.data.Groups) || [];
      for (let i = 0; i < groups.length; i++) {
        const sub = (groups[i].Subs || []).find(
          (s) => s.CustomerProviderId == r.CustomerProviderId
        );
        if (sub) {
          const base = groups[i].ProviderName || r.ProviderName || "#" + r.ProviderId;
          out.CustomerProviderId = sub.Username ? base + " - " + sub.Username : base;
          break;
        }
      }
      // Groups filtre disi kalmissa: filtre dropdown'u icin zaten yuklenmis olan
      // {Id, Name} projeksiyonuna dus (loadCustomerOptions, ayni etiket formulu).
      if (!out.CustomerProviderId) {
        const cp = (this.providers || []).find(
          (x) => x.Id == r.CustomerProviderId
        );
        if (cp) out.CustomerProviderId = cp.Name;
      }
      // MailId icin ayri etiket yok: Subject/FromAddress/ReceiveDate zaten
      // "Mail" grubunda MailId'nin yaninda gorunuyor.
      return out;
    },
    customerOptions() {
      return (this.customers || []).map((x) => {
        return { value: x.Id, text: x.Name };
      });
    },
    /* [SECIM+REUPLOAD gecici kapali]
    selectedCount() {
      return this.selects.length;
    },
    selectedRows() {
      if (this.data == null || !this.data.Rows) return [];
      return this.data.Rows.filter((r) => this.selects.indexOf(r.Id) > -1);
    },
    */
    cardButtons() {
      if (this.unVisibleData.length > 0) {
        return [
          {
            title: "Tekrar Gösterme Yapılan Rezervasyonlar",
            class: "btn-secondary btn-sm",
            icon: "fa fa-eye-slash",
            emit: "showUnvisible",
          },
        ];
      }
      return [];
    },
    unVisibleData() {
      return this.data && this.data.Rows
        ? this.data.Rows.filter((x) => x && x.UnVisible === true)
        : [];
    },
    setRezTypeCount() {
      return (type) => {
        if (this.data == null) return 0;
        if (type == undefined) {
          return this.data.Rows.filter(
            (x) => x.ConfirmationType < 1 || x.ConfirmationType > 3
          ).length;
        }
        return this.data.Rows.filter((x) => x.ConfirmationType == type).length;
      };
    },
    isClear() {
      let dirty = false;
      Object.keys(this.model).forEach((k) => {
        const v = this.model[k];
        if (k == "SearchVoucherType") return;
        if (Array.isArray(v)) {
          if (v.length > 0) dirty = true;
        } else if (v != null && v !== "") {
          dirty = true;
        }
      });
      return dirty;
    },
    getRows() {
      if (this.data == null) return [];
      let rows = this.data.Rows.filter(
        (x) =>
          this.filter.type.indexOf(x.ConfirmationType) > -1 ||
          this.filter.type.indexOf(0) > -1 ||
          (this.filter.type.indexOf("other") > -1 &&
            (x.ConfirmationType < 1 || x.ConfirmationType > 3))
      ).filter((x) => {
        if (Object.keys(this.groups).length == 0) return true;
        const g = this.groups[x.ProviderId];
        return (
          g != undefined &&
          g.indexOf(x.FullAgencyName || x.ProviderAgency || "—") > -1
        );
      });

      if (this.filter.approve != null) {
        if (this.filter.approve == 0) {
          rows = rows.filter((x) => x.WaitApprove);
        } else if (this.filter.approve > -1) {
          rows = rows.filter((x) => x.ApproveStatus == this.filter.approve);
        } else if (this.filter.approve == -1) {
          rows = rows.filter((x) => x.WaitApprove || x.ApproveStatus > 0);
        }
      }
      return rows;
    },
    // Sol facet: YUKLENEN Rows'tan turetilir (badge = filtre sonucuyla birebir
    // tutar; backend Groups.Count uyumsuzlugu ortadan kalkar). Saglayici -> acente
    // (FullAgencyName) grubu.
    providerFacet() {
      if (this.data == null || !this.data.Rows) return [];
      const map = {};
      this.data.Rows.forEach((r) => {
        const pid = r.ProviderId;
        if (map[pid] == undefined) {
          map[pid] = {
            id: pid,
            name: r.ProviderName || "#" + pid,
            count: 0,
            agc: {},
          };
        }
        map[pid].count++;
        const ag = r.FullAgencyName || r.ProviderAgency || "—";
        map[pid].agc[ag] = (map[pid].agc[ag] || 0) + 1;
      });
      return Object.keys(map)
        .map((k) => map[k])
        .sort((a, b) => b.count - a.count)
        .map((p) => ({
          id: p.id,
          name: p.name,
          count: p.count,
          agencies: Object.keys(p.agc)
            .sort()
            .map((a) => ({ name: a, count: p.agc[a] })),
        }));
    },
  },
  methods: {
    addFilterType(type) {
      if (this.filter.type.indexOf(type) > -1) {
        this.filter.type = this.filter.type.filter((x) => x != type);
      } else {
        this.filter.type.push(type);
        this.filter.type = this.filter.type.filter((x) => x != 0);
      }
      if (this.filter.type.length == 0) {
        this.filter.type = [0];
      }
    },
    changeGroup(id, agency = null) {
      // groups = { [providerId]: [acenteAdi, ...] }. Saglayici tiklaninca tum
      // acenteleri secilir; acente tek tek eklenir/cikarilir.
      if (this.groups[id] == undefined) {
        this.groups[id] = [];
        if (agency == null) {
          const p = this.providerFacet.find((x) => x.id == id);
          if (p) p.agencies.forEach((a) => this.groups[id].push(a.name));
        } else {
          this.groups[id].push(agency);
        }
      } else {
        if (agency == null) {
          delete this.groups[id];
        } else {
          if (this.groups[id].indexOf(agency) > -1) {
            this.groups[id] = this.groups[id].filter((x) => x != agency);
            if (this.groups[id].length == 0) {
              delete this.groups[id];
            }
          } else {
            this.groups[id].push(agency);
          }
        }
      }
    },
    /* [SECIM+REUPLOAD gecici kapali] Secim + dokuman yeniden yukleme metodlari.
       Geri acmak icin bu blok yorumunu kaldir.
    onCellDoubleClicked(e) {
      // isSelected (checkbox) hucresi haric cift-tik -> detay modali.
      if (e.colDef && e.colDef.field === "isSelected") return;
      this.detailShow = e.data;
    },
    clickedCell(event) {
      if (event.colDef.field !== "isSelected") return;
      const item = event.data;
      const id = item.Id;
      const isNowSelected = this.selects.indexOf(id) === -1;
      if (isNowSelected) {
        this.selects.push(id);
      } else {
        this.selects = this.selects.filter((x) => x != id);
      }
      item.isSelected = isNowSelected;
      this.$refs.agGrid.changeRow("Id", { ...item });
    },
    selectAllClick() {
      const api = this.$refs.agGrid && this.$refs.agGrid.gridApi;
      if (!api) return;
      // Sadece MEVCUT SAYFADAKI satirlar (unVisibleModal ile ayni mantik):
      // getDisplayedRowCount() tum filtreli satirlari verir, pagination dilimiyle sinirla.
      const total = api.getDisplayedRowCount();
      const pageSize = api.paginationGetPageSize
        ? api.paginationGetPageSize()
        : total;
      const currentPage = api.paginationGetCurrentPage
        ? api.paginationGetCurrentPage()
        : 0;
      const start = currentPage * pageSize;
      const end = Math.min(start + pageSize, total);
      const on = this.selectAll;
      for (let i = start; i < end; i++) {
        const node = api.getDisplayedRowAtIndex(i);
        if (!node || !node.data) continue;
        const item = node.data;
        const id = item.Id;
        const already = this.selects.indexOf(id) > -1;
        if (on && !already) this.selects.push(id);
        else if (!on && already) this.selects = this.selects.filter((x) => x != id);
        item.isSelected = on;
        this.$refs.agGrid.changeRow("Id", { ...item });
      }
    },
    reUploadUrl(item) {
      // kolayrezClient/src/App.vue reUploadVoucherFile ile BIREBIR: SoftwareId'ye
      // gore path. $appAxios = Users/ base -> tam: Users/Reservations/Transfer/{Id}.
      const sw = item.SoftwareId;
      if ([9, 13, 14, 15, 16].indexOf(sw) > -1) {
        return "Reservation/" + sw + "/Transfer/" + item.Id;
      }
      return "Reservations/Transfer/" + item.Id;
    },
    reUploadDocuments(rows) {
      // Rezervasyonun voucher/belgesini backend'e yeniden yukletir.
      // Endpoint kolayrezClient'ta calisan "PDF Tekrar Yükle" ile ayni (kanit:
      // kolayrezClient/src/App.vue:552). GET-by-id -> toplu = dongu (Promise.all).
      // NOT: Users/ base + interceptor admin token'ini tasir; admin oturumunun bu
      // Users/ ucunda yetkisi backend'de teyit edilmeli (401/403 gelirse Admin/
      // muadili istenecek).
      const list = (rows || []).filter((r) => r && r.Id != null);
      if (list.length === 0) return;
      this.$swal({
        icon: "question",
        title: "Soru",
        text:
          list.length +
          " rezervasyonun belgesi (PDF) yeniden yüklenecek. Onaylıyor musunuz?",
        showCancelButton: true,
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((q) => {
        if (!q.isConfirmed) return;
        this.reUploadProcess = true;
        const calls = list.map((item) =>
          this.$appAxios
            .get(this.reUploadUrl(item))
            .then(() => ({ ok: true }))
            .catch((err) => ({ ok: false, err }))
        );
        Promise.all(calls).then((res) => {
          this.reUploadProcess = false;
          const ok = res.filter((x) => x.ok).length;
          const fails = res.filter((x) => !x.ok);
          if (ok === 0) {
            // Hepsi basarisiz -> gercek hatayi goster (401/403/404 net gorunsun).
            this.$isError(fails[0].err);
            return;
          }
          this.$swal({
            icon: fails.length ? "warning" : "success",
            title: fails.length ? "Kısmi" : "Başarılı",
            text:
              ok +
              " rezervasyonun belgesi yeniden yüklendi" +
              (fails.length ? ", " + fails.length + " başarısız." : "."),
            timer: fails.length ? undefined : 2000,
            showConfirmButton: !!fails.length,
          });
        });
      });
    },
    */
    getContextMenuItems(params) {
      const items = ["copy", "export"];
      const data = params && params.node && params.node.data;
      // Tekrar gösterme yapılmış (UnVisible) rezervasyonda -> sag tik ile ac.
      if (data && data.UnVisible) {
        items.push({
          name: "Tekrar Göster",
          icon: "<i class='fas fa-eye'></i>",
          action: () => this.openUnvisible([data]),
        });
      }

      // IsSaving alani liste modelinde henuz donmuyor (ClickUp 86cawtg3n), o
      // yuzden UnVisible gibi filtrelenemiyor: her satirda gosteriliyor.
      // `data` guard'i sart: ag-grid satirlarin altindaki bos alana sag tikta
      // params.node = null ile cagiriyor.
      if (data) {
        items.push({
          name: "Unlock IsSaving",
          icon: "<i class='fas fa-unlock'></i>",
          action: () => this.unLockIsSaving(data),
        });
      }
      /* [SECIM+REUPLOAD gecici kapali] Dokuman yeniden yukleme (tekil + toplu):
      if (data) {
        items.push({
          name: "Dökümanı Yeniden Yükle (PDF)",
          icon: "<i class='mdi mdi-file-refresh'></i>",
          action: () => this.reUploadDocuments([data]),
        });
      }
      if (this.selectedCount > 1) {
        items.push({
          name:
            "Seçili " + this.selectedCount + " rezervasyonun dökümanını yükle",
          icon: "<i class='mdi mdi-file-refresh'></i>",
          action: () => this.reUploadDocuments(this.selectedRows),
        });
      }
      */
      return items;
    },
    onUnvisibleRefreshed(ids) {
      // DeUnvisible basarili -> ilgili satirlarin UnVisible'ini dusur. unVisibleData
      // computed'i Rows'tan turedigi icin badge + "Tekrar Gösterme..." butonu +
      // modal listesi otomatik guncellenir (yeniden arama gerekmez).
      if (!this.data || !this.data.Rows || !ids || !ids.length) return;
      const set = new Set(ids);
      this.data.Rows.forEach((r) => {
        if (set.has(r.Id)) r.UnVisible = false;
      });
    },
    openUnvisible(rows) {
      // rows verilirse (tek rez / sag tik / detay butonu) ona odakli; yoksa
      // tum unVisible rezervasyonlar (toplu). Ikisi de ayni modalda islenir.
      this.unVisibleModalRows =
        rows && rows.length ? rows : this.unVisibleData;
      this.showNoShowAgainModal = true;
    },
    unLockIsSaving(data) {
      // IsSaving'de takili kalan rezervasyonun kaydini destek ekibi acar.
      // Geri alma yolu yok -> once onay. isSavingProcess ucusta ikinci istegi keser.
      if (!data || !data.Id || this.isSavingProcess) return;
      const label = data.Voucher ? "Voucher " + data.Voucher : "Rezervasyon";
      this.$swal({
        icon: "question",
        title: "Soru",
        text: label + " için IsSaving kilidi açılacak. Onaylıyor musunuz?",
        showCancelButton: true,
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((question) => {
        if (!question.isConfirmed) return;
        this.isSavingProcess = true;
        this.$appAxiosAdmin
          .post(`KOLAYREZ/Reservations/SetIsSavingFalse/${data.Id}`)
          .then(() => {
            this.isSavingProcess = false;
            // Satirda yamanacak alan yok: IsSaving liste yanitinda donmuyor
            // (ClickUp 86cawtg3n). Alan eklendiginde burada r.IsSaving = false.
            this.$swal({
              icon: "success",
              title: "Başarılı",
              text: "IsSaving durumu başarıyla açıldı.",
              timer: 2000,
              showConfirmButton: false,
            });
          })
          .catch((err) => {
            this.isSavingProcess = false;
            console.error(
              `KOLAYREZ/Reservations/SetIsSavingFalse/${data.Id} basarisiz:`,
              err
            );
            this.$isError(err);
          });
      });
    },
    toggleGroup(id) {
      const i = this.openGroups.indexOf(id);
      if (i > -1) this.openGroups.splice(i, 1);
      else this.openGroups.push(id);
    },
    loadCustomerOptions(id) {
      // Secili musteriye gore filtre opsiyonlari (customers/detail ekranlarindaki
      // KESIN endpoint'ler):
      //   Saglayicilar -> Customers/{id}/CustomerProviders
      //   Oteller      -> CustomerHotels/{id}   (alan: Id / Name)
      this.providers = [];
      this.hotels = [];
      if (!id) return;
      this.$appAxiosAdmin
        .get(`Customers/${id}/CustomerProviders`)
        .then((r) => {
          this.providers = (r.data || []).map((x) => {
            const base = x.ProviderName || x.Name || "#" + x.Id;
            const uname = x.Username ? "-" + x.Username : "";
            return { Id: x.Id, Name: base + uname };
          });
        })
        .catch((err) => {
          // Kullaniciya toast yok (bilincli, opsiyon listesi bos kalir);
          // takip loglardan.
          console.error(`Customers/${id}/CustomerProviders yuklenemedi:`, err);
        });
      this.$appAxiosAdmin
        .get(`CustomerHotels/${id}`)
        .then((r) => {
          this.hotels = r.data || [];
        })
        .catch((err) => {
          console.error(`CustomerHotels/${id} yuklenemedi:`, err);
        });
    },
    normalizeDateTime(dateVal, timeVal) {
      if (dateVal == null || dateVal === "") return null;
      if (timeVal == null || timeVal === "") return dateVal;
      let diff = new Date().getTimezoneOffset();
      let combined = dateVal + "T" + timeVal + ":00";
      return moment(
        new Date(combined).setMinutes(new Date(combined).getMinutes() + diff)
      ).format("YYYY-MM-DDTHH:mm:ss");
    },
    clear() {
      this.model.HotelIds = [];
      this.model.ProviderIds = [];
      this.model.CustomerProviderIds = [];
      this.model.Voucher = null;
      this.model.SearchVoucherType = 0;
      this.model.BeginCheckin = null;
      this.model.EndCheckin = null;
      this.model.BeginCheckout = null;
      this.model.EndCheckout = null;
      this.model.BeginSale = null;
      this.model.EndSale = null;
      this.model.BeginAdd = null;
      this.model.EndAdd = null;
      this.model.BeginProcess = null;
      this.model.EndProcess = null;
      this.model.ProcessUserId = null;
      this.model.ReservationStatus = null;
      this.model.ConfirmStatus = null;
      this.model.GuestName = null;
      Object.keys(this.modelTime).forEach((k) => {
        this.modelTime[k] = null;
      });
    },
    // keepVoucherType === true yalniz voucher dropdown'undan (Esitleri/
    // Icerenleri Ara) gelir; diger tum cagrilar (buton, Enter -> event objesi
    // gelir) SearchVoucherType'i sifirlar. Client'taki search(type) ile ayni.
    async search(keepVoucherType) {
      this.openSearchVoucherType = false;
      if (keepVoucherType !== true) {
        this.model.SearchVoucherType = 0;
      }
      // Tek zorunlu alan (Musteri) vee-validate ile denetlenir: eksikse
      // alanin border'i KIRMIZI olur (swal yok), istek atilmaz.
      const valid = await this.$refs.form.validate();
      if (!valid.valid) return;
      // Bos stringleri null'a cevir (SearchVoucherType haric).
      Object.keys(this.model).forEach((element) => {
        if (
          this.model[element] === "" &&
          !Array.isArray(this.model[element]) &&
          element != "SearchVoucherType"
        ) {
          this.model[element] = null;
        }
      });

      this.data = null;
      this.process = true;
      this.groups = {};
      /* [SECIM+REUPLOAD gecici kapali] Yeni arama -> onceki secimi temizle.
      this.selects = [];
      this.selectAll = false;
      */

      const payload = {
        ...this.model,
        BeginSale: this.normalizeDateTime(this.model.BeginSale, this.modelTime.BeginSale),
        EndSale: this.normalizeDateTime(this.model.EndSale, this.modelTime.EndSale),
        BeginAdd: this.normalizeDateTime(this.model.BeginAdd, this.modelTime.BeginAdd),
        EndAdd: this.normalizeDateTime(this.model.EndAdd, this.modelTime.EndAdd),
        BeginProcess: this.normalizeDateTime(this.model.BeginProcess, this.modelTime.BeginProcess),
        EndProcess: this.normalizeDateTime(this.model.EndProcess, this.modelTime.EndProcess),
      };
      // Sozlesme tip uyumu: select/searchSelect string emit edebilir -> sayisal
      // alanlari INT (veya null) olarak yolla.
      const num = (v) =>
        v === null || v === "" || v === undefined ? null : Number(v);
      payload.CustomerId = num(payload.CustomerId);
      payload.ConfirmStatus = num(payload.ConfirmStatus);
      payload.ReservationStatus = num(payload.ReservationStatus);
      payload.ProcessUserId = num(payload.ProcessUserId);
      payload.SearchVoucherType = num(payload.SearchVoucherType) || 0;
      // ID array'leri INT[] (ornek payload ile ayni tip).
      payload.HotelIds = (payload.HotelIds || []).map(Number);
      payload.ProviderIds = (payload.ProviderIds || []).map(Number);
      payload.CustomerProviderIds = (payload.CustomerProviderIds || []).map(Number);
      // ProviderAgencies UI'dan kaldirildi (kullanici secemez); backend
      // kontrati alani bekledigi icin her zaman BOS dizi gider.
      payload.ProviderAgencies = [];

      if (this.controller) {
        this.controller.abort();
      }
      this.controller = new AbortController();
      const seq = ++this.searchSeq;

      this.$appAxiosAdmin
        .post(`KOLAYREZ/Reservations/List`, payload, {
          signal: this.controller.signal,
        })
        .then((response) => {
          if (seq !== this.searchSeq) return; // bayat yanit: yeni arama devraldi
          let rows = [];
          (response.data.Rows || []).forEach((element) => {
            rows.push({
              ...element,
              /* [SECIM+REUPLOAD gecici kapali] isSelected: false, */
              ConfirmationTypeText:
                element.ConfirmationType == 1
                  ? "New"
                  : element.ConfirmationType == 2
                  ? "Changed"
                  : element.ConfirmationType == 3
                  ? "Cancelled"
                  : element.ConfirmationType == 4
                  ? "Booked"
                  : element.ConfirmationType == 5
                  ? "Request"
                  : "None",
              YCB: element.Adult + "+" + element.Child + "+" + element.Infant,
            });
          });
          this.data = {
            Groups: response.data.Groups || [],
            Rows: rows,
          };
          this.filter = { type: [0], approve: null };
          this.process = false;
        })
        .catch((err) => {
          // Bayat/iptal edilen istegin hatasi da yok sayilir. (ERR_CANCELED
          // ancak axios >= 0.27'de olusur; ileriye donuk duruyor.)
          if (seq !== this.searchSeq) return;
          if (err && err.code === "ERR_CANCELED") return;
          this.process = false;
          console.error("KOLAYREZ/Reservations/List basarisiz:", err);
          this.$isError(err);
        });
    },
  },
};
</script>

<style scoped>
.groupBox .row {
  margin: 0 -5px;
}
.groupBox .row > div {
  padding: 0 5px;
}
/* Voucher arama-butonu dropdown'i (Esitleri/Icerenleri Ara) alani icinde konumlansin */
.groupBox .voucher {
  position: relative;
}
/* Sol facet + provider tree + onay filtresi client'in birebir markup'i
   (inbox-panel / list-group / list-group-item / treeViewInput /
   filled-in chk-col-teal / badge badge-*) -> GLOBAL stillere birakildi,
   client ekranindaki gorunumu birebir uretir. Asagida sadece hafif cila. */
/* Sol facet — sade, tema-uyumlu cila (soft SaaS): hover + aktifte marka aksan
   cizgisi, ikon/label/badge hizasi, agac kaydirmasi. */
.filter {
  width: 240px;
  background: var(--bg-secondary, #f7f8fa);
}
.filter .list-group,
.filter .list-group-full {
  margin: 0;
}
.filter .list-group-item {
  cursor: pointer;
  padding: 11px 13px;
  border: none;
  border-top: 1px solid var(--border-default, #ececf0);
  background: transparent;
  transition: background 0.12s ease, box-shadow 0.12s ease;
}
.filter .list-group-item:first-child {
  border-top: none;
}
.filter .list-group-item:hover {
  background: var(--bg-hover, rgba(0, 0, 0, 0.035));
}
.filter .list-group-item.active {
  background: var(--bg-selected, rgba(30, 136, 229, 0.10));
  box-shadow: inset 3px 0 0 var(--color-brand-500, #1e88e5);
}
/* 13px + weight 400 okunmuyordu (global .inbox-panel stili de #67757c gri
   veriyor). Sol facet surekli taranan bir yer -> punto ve agirlik artti. */
.filter .list-group-item a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--text-primary, #23232a);
  font-size: 14.5px;
  font-weight: 600;
  line-height: 1.3;
}
/* Aktif satirda once yalniz zemin degisiyordu; metin de secili gorunsun. */
.filter .list-group-item.active a {
  font-weight: 700;
  color: var(--color-brand-600, #1565c0);
}
.filter .list-group-item.active a i {
  color: var(--color-brand-500, #1e88e5);
}
.filter .list-group-item a i {
  width: 17px;
  text-align: center;
  font-size: 15px;
  color: var(--text-secondary, #7a7a85);
}
/* Sayilar dikey bir kolon halinde okunuyor -> tabular-nums ile hizalanir. */
.filter .list-group-item a .badge {
  margin-left: auto;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 8px;
  font-variant-numeric: tabular-nums;
}
/* "New" bir DURUM, basari degil -> yesil badge yanlis anlam veriyordu; modaldaki
   durum semasiyla ayni (New mavi). "Onaylananlar" yesil KALIYOR, o gercekten
   basari/onay anlamina geliyor. */
.filter .list-group-item a .badge.badge-success {
  background-color: #1e88e5;
}
.filter .inbox-panel + .inbox-panel .list-group-item a .badge.badge-success {
  background-color: #1a8a55;
}
/* Saglayici agaci — ferah, okunur: satir padding'i, hover, net girinti. */
.kr-provtree {
  max-height: 340px;
  overflow-y: auto;
  padding: 6px;
  border-top: 1px solid var(--border-default, #ececf0);
}
.kr-prov + .kr-prov {
  margin-top: 2px;
}
.kr-prov-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  transition: background 0.12s ease;
}
.kr-prov-row:hover {
  background: var(--bg-hover, rgba(0, 0, 0, 0.04));
}
.kr-cb {
  position: relative;
  flex: 0 0 22px;
  width: 22px;
  height: 22px;
}
.kr-cb label {
  padding-left: 0 !important;
  height: 22px;
  min-height: 22px;
}
.kr-prov-name {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary, #23232a);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.kr-prov-name.clickable {
  cursor: pointer;
}
.kr-prov-name.clickable:hover {
  color: var(--color-brand-500, #1e88e5);
}
.kr-prov-count {
  flex: 0 0 auto;
  min-width: 28px;
  text-align: center;
  padding: 2px 9px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  background: var(--color-brand-500, #1e88e5);
  color: #fff;
}
.kr-chevron {
  flex: 0 0 auto;
  cursor: pointer;
  font-size: 12px;
  color: var(--text-secondary, #8a8a93);
  padding: 6px;
  border-radius: 6px;
}
.kr-chevron:hover {
  background: var(--bg-tertiary, #ececf0);
  color: var(--text-primary, #23232a);
}
.kr-prov-subs {
  margin: 2px 0 8px 16px;
  padding: 4px 0 4px 12px;
  border-left: 2px solid var(--color-brand-500, #1e88e5);
}
.kr-sub-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  border-radius: 8px;
  transition: background 0.12s ease;
}
.kr-sub-row:hover {
  background: var(--bg-hover, rgba(0, 0, 0, 0.04));
}
.kr-sub-name {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--text-primary, #2a2a32);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.kr-sub-count {
  flex: 0 0 auto;
  min-width: 26px;
  text-align: center;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  background: var(--bg-tertiary, #e8e8ee);
  color: var(--text-secondary, #5a5a63);
}
.kr-notes-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.kr-note-row {
  padding: 8px 12px;
  border-radius: 8px;
  background: var(--bg-secondary, #f6f7f9);
  border: 1px solid var(--border-default, #e6e6ea);
  font-size: 13px;
  white-space: pre-wrap;
}

/* [SECIM+REUPLOAD gecici kapali] Ana grid secim toolbar CSS'i. Geri acmak icin
   bu yorumu kaldir. (Icerideki checkbox kurali Materialize'in global checkbox
   gizlemesini ezer: position/opacity/appearance override + accent-color teal.)
.kr-grid-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  min-height: 40px;
  border-bottom: 1px solid var(--border-default, #e6e6ea);
  background: var(--bg-secondary, #f6f7f9);
}
.kr-toolbar-spacer {
  flex: 1 1 auto;
}
.kr-sel-count {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-brand-600, #1565c0);
}
.kr-selectall {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary, #23232a);
  white-space: nowrap;
  user-select: none;
}
.kr-selectall input[type="checkbox"] {
  position: static !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  -webkit-appearance: checkbox !important;
  -moz-appearance: checkbox !important;
  appearance: auto !important;
  width: 16px;
  height: 16px;
  accent-color: var(--color-brand-500, #1e88e5);
  cursor: pointer;
  margin: 0;
  flex: 0 0 auto;
}
.kr-bulk-btn {
  flex: 0 0 auto;
  white-space: nowrap;
}
*/
</style>

<style>
/* NON-SCOPED: ag-grid hucre HTML'i scoped data-v almadigi icin bu blok global.
   Mektup (NoteCount) ikonu + ustunde yanip sonen kirmizi nokta. */
.kr-note {
  position: relative;
  display: inline-block;
  line-height: 1;
  cursor: pointer;
}
.kr-note .kr-note-mail {
  font-size: 16px;
  color: #3b7ddd;
  vertical-align: middle;
}
.kr-note-dot {
  position: absolute;
  top: -2px;
  right: -4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e53935;
  border: 1px solid #fff;
  animation: kr-note-blink 1.1s ease-in-out infinite;
}
@keyframes kr-note-blink {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.25;
    transform: scale(0.6);
  }
}
@media (prefers-reduced-motion: reduce) {
  .kr-note-dot {
    animation: none;
  }
}
</style>
